import { render } from "./Strategy.vue?vue&type=template&id=29c9f4a4"
import script from "./Strategy.vue?vue&type=script&lang=js"
export * from "./Strategy.vue?vue&type=script&lang=js"
script.render = render

export default script